import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { ThemeUIProvider, merge } from 'theme-ui'
import { useThemedStylesWithMdx } from '@theme-ui/mdx'
import { MDXProvider, useMDXComponents } from '@mdx-js/react'

import localTheme from '@sudaraka94/gatsby-theme-novela/src/gatsby-plugin-theme-ui'

const components = {}
const Root = ({ children }) => {
  const { themeUiConfig } = useStaticQuery(graphql`
    query {
      themeUiConfig(id: { eq: "gatsby-plugin-theme-ui-config" }) {
        preset
        prismPreset
      }
    }
  `)
  const { preset, prismPreset } = themeUiConfig

  const fullTheme = React.useMemo(() => {
    const theme = preset.default || preset
    const themeWithPrism = merge(theme, {
      styles: {
        pre: prismPreset,
      },
    })
    return merge(themeWithPrism, localTheme)
  }, [preset, prismPreset])

  const mdxComponents = useThemedStylesWithMdx(useMDXComponents(components))

  return React.useMemo(
    () => (
      <ThemeUIProvider theme={fullTheme}>
        <MDXProvider components={mdxComponents}>{children}</MDXProvider>
      </ThemeUIProvider>
    ),
    [fullTheme, mdxComponents, children]
  )
}

export const WrapRootElement = ({ element }) => {
  return <Root>{element}</Root>
}
